export default (element: HTMLElement) => {
  void element.offsetHeight;
};
